import './styles.css';
import type { DayVacation } from './types';
import { renderSemester } from './calendar/render';
import { buildVacationDayMap, loadCalendarYear } from './vacations';
import { mountClock } from './widgets/clock';

interface State {
  year: number;
  semester: 0 | 1;
  showVacations: boolean;
  vacations: Map<string, DayVacation>;
  vacYear: number | null;
}

const today = new Date();

const state: State = {
  year: today.getFullYear(),
  semester: today.getMonth() < 6 ? 0 : 1,
  showVacations: true,
  vacations: new Map(),
  vacYear: null,
};

const app = document.getElementById('app');
if (!app) throw new Error('#app missing');

app.innerHTML = `
  <header class="topbar">
    <h1 class="topbarTitle">Calendrier</h1>
  </header>
  <main class="layout">
    <section class="calendar">
      <div class="calendarHead">
        <span class="calendarTitle"></span>
      </div>
      <div class="calendarBody"></div>
      <div class="calendarFoot">
        <button type="button" class="btn" data-act="today" title="Revenir à aujourd'hui">⌂ Aujourd'hui</button>
        <button type="button" class="btn" data-act="prev"  title="Semestre précédent">‹</button>
        <span class="semesterLabel"></span>
        <span class="yearLabel"></span>
        <button type="button" class="btn" data-act="next"  title="Semestre suivant">›</button>
      </div>
    </section>
    <aside class="sidebar">
      <div class="panel vacationPanel">
        <div class="panelTitle">
          <label>
            <input type="checkbox" class="vacToggle" checked />
            Vacances scolaires
          </label>
        </div>
        <div class="zoneLegend">
          <span class="zoneTag zoneTag-A"><span class="zoneSwatch"></span>Zone A
            <span class="zoneCities">Besançon, Bordeaux, Clermont-Ferrand, Dijon, Grenoble, Limoges, Lyon, Poitiers</span></span>
          <span class="zoneTag zoneTag-B"><span class="zoneSwatch"></span>Zone B
            <span class="zoneCities">Aix-Marseille, Amiens, Caen, Lille, Nancy-Metz, Nantes, Nice, Orléans-Tours, Reims, Rennes, Rouen, Strasbourg</span></span>
          <span class="zoneTag zoneTag-C"><span class="zoneSwatch"></span>Zone C
            <span class="zoneCities">Créteil, Montpellier, Paris, Toulouse, Versailles</span></span>
        </div>
        <div class="vacSource">
          Source :
          <a href="https://data.education.gouv.fr/explore/dataset/fr-en-calendrier-scolaire/"
             target="_blank" rel="noopener">data.education.gouv.fr</a>
        </div>
      </div>
      <div class="panel clockMount"></div>
      <div class="panel about">
        Recréé d'après <a href="http://www.almanach.free.fr/" target="_blank" rel="noopener">almanach.free.fr</a>.
      </div>
    </aside>
  </main>
`;

const title = app.querySelector<HTMLElement>('.calendarTitle')!;
const yearLabel = app.querySelector<HTMLElement>('.yearLabel')!;
const semesterLabel = app.querySelector<HTMLElement>('.semesterLabel')!;
const calendarMount = app.querySelector<HTMLElement>('.calendarBody')!;
const vacToggle = app.querySelector<HTMLInputElement>('.vacToggle')!;
const clockMount = app.querySelector<HTMLElement>('.clockMount')!;

mountClock(clockMount);

function paint(): void {
  title.textContent = `Calendrier ${state.year}`;
  yearLabel.textContent = String(state.year);
  semesterLabel.textContent = state.semester === 0 ? 'Jan – Juin' : 'Juil – Déc';
  const grid = renderSemester({
    year: state.year,
    semester: state.semester,
    showVacations: state.showVacations,
    vacations: state.vacations,
  });
  calendarMount.replaceChildren(grid);
}

async function ensureVacations(year: number): Promise<void> {
  if (state.vacYear === year) return;
  state.vacYear = year;
  try {
    const ranges = await loadCalendarYear(year);
    if (state.vacYear !== year) return;
    state.vacations = buildVacationDayMap(ranges);
    paint();
  } catch (err) {
    console.warn('vacation load failed', err);
  }
}

function refresh(): void {
  paint();
  void ensureVacations(state.year);
}

app.querySelector('[data-act="today"]')!.addEventListener('click', () => {
  state.year = today.getFullYear();
  state.semester = today.getMonth() < 6 ? 0 : 1;
  refresh();
});
app.querySelector('[data-act="prev"]')!.addEventListener('click', () => {
  if (state.semester === 0) {
    state.semester = 1;
    state.year -= 1;
  } else {
    state.semester = 0;
  }
  refresh();
});
app.querySelector('[data-act="next"]')!.addEventListener('click', () => {
  if (state.semester === 1) {
    state.semester = 0;
    state.year += 1;
  } else {
    state.semester = 1;
  }
  refresh();
});
vacToggle.addEventListener('change', () => {
  state.showVacations = vacToggle.checked;
  paint();
});

refresh();
